import Vue from 'vue'

let paypal = new Vue({
  data () {
    return {}
  },

  methods: {
    formPaypal (datos) {
      var form = document.createElement('form')
      form.setAttribute('id', 'paypal')
      form.setAttribute('method', 'POST')
      form.setAttribute('action', datos.action)
      document.body.appendChild(form)

      for (const item in datos) {
        if (item && item !== 'action') {
          var input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', item)
          input.setAttribute('value', datos[item])
          form.appendChild(input)
        }
      }
      form.submit()
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$paypal = paypal
  }
}
